import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { FileSaverService } from 'ngx-filesaver';
import { finalize, switchMap, takeUntil } from 'rxjs/operators';

import { DataImportEntityEnum, DataImportEntityGroupEnum } from '../../models';
import { DataImportApiService } from '../../data-import-api.service';
import { getContentDispositionFileName } from 'common/src/modules/rnpl-common/helpers';
import { FileUploadParams } from 'common/src/models/file-upload-params.model';
import { NavBarBtnModel } from 'common/src/models';
import { FileService } from 'common/src/services/file.service';
import { DATA_IMPORT_NAVBAR_BUTTONS, DATA_IMPORT_PARTNERS_NAVBAR_BUTTONS } from './download-template.config';
import { ProductTypes } from 'common/src/modules/products/product-types';
import { ToasterService } from 'common/src/modules/ui-components/toaster';

@Component({
  selector: 'rnpl-download-template',
  templateUrl: './download-template.component.html',
  styleUrls: ['./download-template.component.scss']
})
export class DownloadTemplateComponent implements OnChanges, OnDestroy {
  @Input() importEntityGroupEnum: DataImportEntityGroupEnum = null;
  @Input() productType: ProductTypes;
  @Input() greyButton: boolean;

  public navBarButtons: NavBarBtnModel[] = DATA_IMPORT_NAVBAR_BUTTONS;
  public entityGroupEnum = DataImportEntityGroupEnum;
  public entityEnum = DataImportEntityEnum;

  public readonly destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  public readonly btnToClearLoadingStatus$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(
    private fileService: FileService,
    private fileSaverService: FileSaverService,
    private dataImportApiService: DataImportApiService,
    private toasterService: ToasterService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.hasOwnProperty('importEntityGroupEnum')) {
      // if (this.importEntityGroupEnum === DataImportEntityGroupEnum.PRODUCTS) {
      //   this.navBarButtons = DATA_IMPORT_PRODUCTS_NAVBAR_BUTTONS;
      // }
      if (this.importEntityGroupEnum === DataImportEntityGroupEnum.PARTNERS) {
        this.navBarButtons = DATA_IMPORT_PARTNERS_NAVBAR_BUTTONS;
      }
    }
  }

  public actionsEventWithValue(e: { actionName: string, returnValue: DataImportEntityEnum }): void {
    if (!this[e.actionName]) { return; }
    this[e.actionName](e.returnValue);
  }

  public downloadTemplate(entity: DataImportEntityEnum): void {
    let request$: Observable<FileUploadParams>;

    switch (entity) {
      case DataImportEntityEnum.PAYMENTS:
        request$ = this.dataImportApiService.getImportPaymentsTemplateParams();
        break;
      case DataImportEntityEnum.PARTNER_ACCOUNT:
        request$ = this.dataImportApiService.getImportPartnersAccounts();
        break;
      default:
        request$ = this.dataImportApiService.getImportTemplateParams(entity);
    }

    request$
      .pipe(
        switchMap((fileParams: FileUploadParams) => this.fileService.downloadFile(fileParams.url)),
        finalize(() => this.btnToClearLoadingStatus$.next('downloadTemplate')),
        takeUntil(this.destroy$)
      )
      .subscribe((res: any) => {
        this.fileSaverService.save(
          res.body,
          getContentDispositionFileName(res.headers.get('Content-Disposition'))
        );
      }, (error) => {
        this.toasterService.notify({type: 'error', message: error.error.message});
      });
  }

  public downloadProductsTemplate(productType: ProductTypes): void {
    switch (productType) {
      case ProductTypes.GOODS:
        this.downloadTemplate(DataImportEntityEnum.GOODS);
        break;
      case ProductTypes.SERVICES:
        this.downloadTemplate(DataImportEntityEnum.SERVICES);
        break;
      case ProductTypes.DIGITAL:
        this.downloadTemplate(DataImportEntityEnum.DIGITAL_PRODUCTS);
        break;
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
